import produce from "immer";
import {
  SET_PROGRESS_REQUEST,
  SET_PROGRESS_REQUEST_SUCCESS,
  SET_PROGRESS_REQUEST_ERROR,
  GET_PROGRESS_REQUEST,
  GET_PROGRESS_REQUEST_ERROR,
  GET_PROGRESS_REQUEST_SUCCESS,
} from "./constants";

export const initialState = {
  error: null,
  loading: false,
  data: null,
  result: null,
};

const progressReducer = (state = initialState, action) => {
  return produce(state, (draftState) => {
    switch (action.type) {
      case SET_PROGRESS_REQUEST:
        draftState.loading = true;
        draftState.error = null;
        break;
      case SET_PROGRESS_REQUEST_SUCCESS:
        draftState.loading = false;
        draftState.data = action.data;
        break;
      case SET_PROGRESS_REQUEST_ERROR:
        draftState.loading = false;
        draftState.error = action.data;
        break;

      case GET_PROGRESS_REQUEST:
        draftState.loading = true;
        draftState.error = null;
        break;
      case GET_PROGRESS_REQUEST_SUCCESS:
        draftState.loading = false;
        draftState.result = action.data;
        break;
      case GET_PROGRESS_REQUEST_ERROR:
        draftState.loading = false;
        draftState.error = action.data;
        break;
      default:
        break;
    }
  });
};

export default progressReducer;
